import { appConfig } from '../../constants/app-config';

export const cloudinaryServiceModule = angular
  .module('Q.services.cloudinary-service', [])
  .factory('cloudinaryService', function ($window) {
    const dpr = $window.devicePixelRatio;
    const factor = dpr > 1 ? dpr : false;

    const service = {
      getUrl: function (fileId, params) {
        params = params || {
          width: 200,
        };
        // either the id itself, a model or a upload result can be passed in
        if (angular.isObject(fileId)) {
          if (!fileId.width) return null;
          if (
            !params.format &&
            /^(gif|jpe?g|png|svg)$/.test(fileId.fileFormat)
          ) {
            params.format = fileId.fileFormat;
          }
          /*jshint camelcase: false */
          fileId = fileId.fileId || fileId.public_id;
        }

        // support null values so that its easier to consume this method
        if (!fileId) return null;

        if (factor && params.retina) {
          if (params.width) params.width = Math.ceil(params.width * factor);
          if (params.height) params.height = Math.ceil(params.height * factor);
        }
        // cap at 5000px
        if (params.width) params.width = Math.min(5000, params.width);
        if (params.height) params.height = Math.min(5000, params.height);

        const options = [];
        toOption(params.width, 'w');
        toOption(params.height, 'h');
        toOption(params.x, 'x');
        toOption(params.y, 'y');
        toOption(params.radius, 'r');
        toOption(params.transformation, 't');
        toOption(params.quality, 'q');
        toOption(params.angle, 'a');
        toOption(params.effect, 'e');

        // valid crop values are crop/scale/fit/fill/limit/pad/thumb
        toOption(params.crop, 'c');

        // valid gravity values include face/faces/north_west/north_east/south_west/south_east
        toOption(params.gravity, 'g');

        return `${appConfig.cloudinaryBaseUrl}${options.join(',')}/${fileId}.${params.format || 'png'}`;

        function toOption(value, prefix) {
          if (value) {
            options.push(prefix + '_' + value);
          }
        }
      },
    };

    return service;
  })

  .filter('cloudinaryImage', function (cloudinaryService) {
    return function (field, width, height, retina) {
      if (height === true) {
        height = null;
        retina = true;
      }
      return cloudinaryService.getUrl(field, { width, height, retina });
    };
  });
